<template>
	<el-dialog :close-on-click-modal="false" :close-on-press-escape="false" :show-close="true" :visible.sync="dialogVisible" destroy-on-close title="转账凭证信息" width="600px">
		<div>
			<el-form ref="formRef" label-width="100px">
				<el-row :gutter="20">
					<el-col :span="24">
						<el-form-item >
							<div v-if="corporateInfoUrl">
								<el-image :preview-src-list="[corporateInfoUrl]" style="width: 300px; height: 300px" :src="corporateInfoUrl" fit="contain"></el-image>
							</div>
						</el-form-item>
					</el-col>
				</el-row>
			</el-form>
		</div>
		<template #footer>
			<div class="dialog-footer">
				<el-button size="small" @click="dialogVisible = false">关闭</el-button>
			</div>
		</template>
	</el-dialog>
</template>

<script>

export default {
	name: 'DialogShowPayInfo',
    props: {
        corporateInfoUrl: {
            type: String,
            default: ''
        }
    },
	data() {
		return {
			dialogVisible: false,
		};
	},
	methods: {
		handleClose() {
			this.dialogVisible = false;
        },

		
	}
};
</script>

<style lang="less" scoped>
// 弹出框重置样式
/deep/ .el-dialog__header {
	border-bottom: 1px dashed #e2e8f0;
	margin-right: 0;
	background: #f8fafc;
}

/deep/ .el-dialog__headerbtn .el-dialog__close {
	color: #3a434f;
	font-size: 24px;
}

/deep/ .el-dialog__footer {
	border-top: 1px solid #e8e8e8;
	padding: 18px;
}

/deep/ .el-dialog__body .el-form-item__label {
	line-height: 26px;
}
</style>
